import { yup } from '@guiker/yup-util'

export const legacyPaymentVerificationApiConfigSchema = yup
  .object({
    baseUrl: yup.string().required(),
    publicKey: yup.string().required(),
    secretKey: yup.string().required(),
  })
  .required()
